import React, { useCallback, useMemo } from 'react';
import { Box } from '@mui/material';

import { splitMentions } from '../../helpers';
import { User } from '../../types';
import styles from './style';

interface MentionTextProps {
  text: string;
  mentions?: User[];
  // Every @token is colored, even without the list of the users.
  all?: boolean;
  // Without it the @username are only colored.
  onOpenUser?: (userId: string) => void;
}

// A message with its @username colored, clickable when a handler is given.
const MentionText: React.FC<MentionTextProps> = React.memo((props) => {
  const {
    text,
    mentions,
    all,
    onOpenUser,
  } = props;

  const segments = useMemo(() => splitMentions(text, mentions, all), [all, mentions, text]);

  const onClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    const { id } = event.currentTarget.dataset;
    if (onOpenUser && id) {
      onOpenUser(id);
    }
  }, [onOpenUser]);

  return (
    <>
      {segments.map((segment, index) => {
        if (!segment.user) {
          // eslint-disable-next-line react/no-array-index-key
          return <Box key={index} component="span" sx={styles.text}>{segment.text}</Box>;
        }
        if (!onOpenUser || !segment.user.id) {
          // eslint-disable-next-line react/no-array-index-key
          return <Box key={index} component="span" sx={styles.mention}>{segment.text}</Box>;
        }
        return (
          <Box
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            component="button"
            type="button"
            data-id={segment.user.id}
            onClick={onClick}
            sx={styles.mentionButton}
          >
            {segment.text}
          </Box>
        );
      })}
    </>
  );
});

export default MentionText;
